import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus-circle",
  "use": "plus-circle-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"plus-circle\">\n<rect width=\"20\" height=\"20\" rx=\"10\" fill=\"#D52A3F\" />\n<path d=\"M7.28109 10.744H9.68909V13.222H11.3131V10.744H13.7211V9.26H11.3131V6.782H9.68909V9.26H7.28109V10.744Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol